import { communityRegions } from '../community/constants';

export const jobPostAbroadRegion = 'Abroad' as const;

export const jobPostRegions = [jobPostAbroadRegion, ...communityRegions] as const;

export const JobPostLocationType = {
  Onsite: 'Onsite',
  Hybrid: 'Hybrid',
  Remote: 'Remote',
} as const;

export const jobPostLocationTypes = [JobPostLocationType.Onsite, JobPostLocationType.Hybrid, JobPostLocationType.Remote] as const;

export const jobPostPriceUnits = ['Hourly', 'HalfDaily', 'Daily', 'Fixed', 'PricePerWord'] as const;

export const jobPostPriceTypes = [...jobPostPriceUnits, 'Tbd'] as const;

export const jobPostExperienceLevels = ['Junior', 'Medior', 'Senior'] as const;

export const jobPostSources = ['Internal', 'External'] as const;

export const jobPostStatuses = ['Open', 'Filled', 'Cancelled'] as const;

export const jobPostApplyMode = ['ExternalEmail', 'ExternalUrl', 'InternalEmail'] as const;
